import Vue from 'vue'
import Router from 'vue-router'
import Top from '@/components/public/top'
import Header from '@/components/public/Header'
import Bottom from '@/components/public/Bottom'
import MainFrame from '@/components/MainFrame'
import Show from '@/components/Show'
import Article from '@/components/Article'
import Search from '@/components/Search'
import Activity from '@/components/activity'
import Magazine from '@/components/magazine'
import Maglist from '@/components/Maglist'
import Atrcallist from '@/components/Atrcallist'
import ArticleMagazine from '@/components/articleMagazine'
import Video from '@/components/video'
import Info from '@/components/info'
import Research from '@/components/research'
import RealtimeArticle from '@/components/RealtimeArticle'
import ResearchDetail from '@/components/ResearchDetail'
import Reallist from '@/components/RealList'


Vue.use(Router)
export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',name: 'Show',component: Show,
    },

    {	  
	    path: '/article/list/:typeid?',name: 'Atrcallist', component: Atrcallist	
    },
    {
      path: '/article/:id',name: 'Article', component: Article
    },

    {	  
	    path: '/search',name: 'Search', component: Search	
    },

    {	  
	    path: '/activity',name: 'Activity', component: Activity	
    },

    {	  
	    path: '/magazine',name: 'Magazine', component: Magazine	
    },
    {	  
	    path: '/maglist/detail/:uniqueid',name: 'Maglist', component: Maglist
    },
    {	  
	    path: '/magartical/:artuniqueid',name: 'ArticleMagazine', component: ArticleMagazine
    },
    {	  
	    path: '/video/list',name: 'Video', component: Video
    },
    {	  
	    path: '/info/:section',name: 'Info', component: Info
    },
    {	  
	    path: '/research/academy',name: 'Research', component: Research
    },
    {	  
	    path: '/research/detail/:researcher_uniqueid',name: 'ResearchDetail', component: ResearchDetail
    },
    {	  
	    path: '/realtimedata/artical/:dates/:adid',name: 'RealtimeArticle', component: RealtimeArticle
    },
    {	  
	    path: '/realtimelist',name: 'Reallist', component: Reallist
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js